import { Group, SegmentedControl, Text } from "@mantine/core";

export function TimelineFilters({
  value,
  onChange,
  total,
}: {
  value: string;
  onChange: (value: string) => void;
  total?: number;
}) {
  return (
    <Group justify="space-between">
      <Text size="sm" c="dimmed">
        {total ?? 0} events
      </Text>
      <SegmentedControl
        value={value}
        onChange={onChange}
        data={[
          { label: "All", value: "all" },
          { label: "Auth", value: "auth" },
          { label: "Access", value: "access" },
          { label: "Candidate", value: "candidate" },
          { label: "Submission", value: "submission" },
        ]}
      />
    </Group>
  );
}
